import React, { useMemo } from 'react';
import styled from 'styled-components';

const StyledBg = styled.div`
  background-color: var(--alpha);

  &,
  > .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const FallbackBackground = ({
  backgroundImage,
  children,
  className,
  style
}: {
  backgroundImage?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}): React.ReactElement => {
  const bgStyle = useMemo(
    (): React.CSSProperties => ({
      backgroundImage: backgroundImage
        ? `url('${backgroundImage}')`
        : 'linear-gradient(112.43deg, #000000 0%, rgba(0, 0, 0, 0) 101.58%)',
      backgroundSize: 'cover',
      opacity: backgroundImage ? 1 : 0.5
    }),
    [backgroundImage]
  );

  return (
    <StyledBg className={className} style={style}>
      <div className='bg' style={bgStyle} />
      {children}
    </StyledBg>
  );
};
